import React from "react";

// MATERIAL UI COMPONENTS
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
// ICONS
import CloseIcon from "@mui/icons-material/Close";

function CollapseAlert({
  openErrorAlert,
  setOpenErrorAlert,
  errorMessage,
  severity = "error",
}) {
  return (
    <Collapse in={openErrorAlert}>
      <Alert
        variant="filled"
        severity={severity}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpenErrorAlert(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {errorMessage}
      </Alert>
    </Collapse>
  );
}

export default CollapseAlert;
